import { ThemeProvider } from '@mui/material/styles';
import { Redirect, Route, Switch } from 'react-router-dom';
import ClassLayout from './layout/ClassLayout';
import LessonBuilderLayout from './layout/LessonBuilderLayout';
import LessonWorkspaceLayout from './layout/LessonWorkspaceLayout';
import LessonDescriptionPdfPage from './page/LessonDescriptionPdfPage';
import TeacherDashboardPage from './page/TeacherDashboardPage';
import MockupBanner from '../MockupBanner';
import mockupTheme from '../mockupTheme';

export default function TeacherExperience() {
    return (
        <ThemeProvider theme={mockupTheme}>
            <MockupBanner surface="Teacher" />
            <Switch>
                <Route exact path="/mockup/teacher" component={TeacherDashboardPage} />
                <Route
                    exact
                    path="/mockup/teacher/class/:classId/lesson/new"
                    render={({ match }: { match: { params: { classId: string } } }) => (
                        <Redirect to={`/mockup/teacher/class/${match.params.classId}/lesson/ordering-food-at-a-restaurant/description`} />
                    )}
                />
                {/* Version B of the description step, copied from the live Create lesson page, with textbook PDF upload. */}
                <Route exact path="/mockup/teacher/class/:classId/lesson/:lessonId/description-pdf" component={LessonDescriptionPdfPage} />
                {/* One route, so LessonBuilderLayout's useParams() actually receives builderStep
                    and the header can show the current stage. */}
                <Route exact path="/mockup/teacher/class/:classId/lesson/:lessonId/:builderStep(description|plan|exercises)" component={LessonBuilderLayout} />
                <Route
                    exact
                    path="/mockup/teacher/class/:classId/lesson/:lessonId"
                    render={({ match }: { match: { params: { classId: string; lessonId: string } } }) => <Redirect to={`/mockup/teacher/class/${match.params.classId}/lesson/${match.params.lessonId}/overview`} />}
                />
                <Route path="/mockup/teacher/class/:classId/lesson/:lessonId/:lessonTab" component={LessonWorkspaceLayout} />
                <Route
                    exact
                    path="/mockup/teacher/class/:classId"
                    render={({ match }: { match: { params: { classId: string } } }) => <Redirect to={`/mockup/teacher/class/${match.params.classId}/overview`} />}
                />
                <Route path="/mockup/teacher/class/:classId/:classTab" component={ClassLayout} />
                <Redirect to="/mockup/teacher" />
            </Switch>
        </ThemeProvider>
    );
}
